import { Link } from "react-router-dom";
import { categories } from "@/mocks/gossip";

export default function CategoryGrid() {
  return (
    <section id="categories" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] uppercase text-primary-600 mb-3">
            <span className="w-6 h-px bg-primary-500 inline-block"></span>
            Categories
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">主题分类</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            按领域浏览瓜料，从娱乐爆料到电竞赛事，每一类都有独立的画面整理与时间线。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/40 transition-colors"
            >
              <span className="w-12 h-12 shrink-0 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={cat.icon} aria-hidden="true"></i>
              </span>
              <span className="flex-1 min-w-0">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-900">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-500 font-label whitespace-nowrap">
                    {cat.count} 条
                  </span>
                </span>
                <span className="mt-1.5 block text-sm text-foreground-600 leading-relaxed">
                  {cat.desc}
                </span>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                  进入分类
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}